import {
  PriceTierDiscountItemType,
  PriceTierDiscountType,
} from "@sellar-io/common";
import { createContext, useContext } from "react";

export type DiscountsPreviewTypeType = "unit" | "spend";

export type SelectedDiscountType = {
  id: number;
  type: PriceTierDiscountType;
  amount: number;
  itemType: PriceTierDiscountItemType | null;
  quantity: number;
  minimumBasketValue: number;
};

type PriceListContextType = {
  discountsPreviewEnabled?: boolean;
  setDiscountsPreviewEnabled?: (value: boolean) => void;
  discountsPreviewType?: DiscountsPreviewTypeType;
  setDiscountsPreviewType?: (type: DiscountsPreviewTypeType) => void;
  numberOfUnits?: number | null;
  setNumberOfUnits?: (value: number | null) => void;
  minimumSpend?: number | null;
  setMinimumSpend?: (value: number | null) => void;
  selectedDiscount?: SelectedDiscountType;
  setSelectedDiscount?: (value: SelectedDiscountType | undefined) => void;
};

export const PriceListContext = createContext<PriceListContextType | undefined>(
  undefined,
);

export const usePriceListContext = () => {
  const context = useContext(PriceListContext);
  if (context === undefined) {
    throw new Error(
      "usePriceListContext must be within PriceListContextProvider",
    );
  }

  return context;
};
